import { TownsquareSiteAri } from '@atlassian/ari';

import type { RelayResourceConfig } from '@townsquare/relay-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import GoalsDirectoryAggOuterQuery, {
	type GoalsDirectoryAggOuterQuery as GoalsDirectoryAggOuterQueryType,
} from '../components/__generated__/GoalsDirectoryAggOuterQuery.graphql';

export const getGoalDirectoryAggResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<GoalsDirectoryAggOuterQueryType> => {
	const context = resourceContext as ResourceContext;
	const cloudId = context.workspace?.cloudId;

	if (!cloudId) {
		throw new Error('goalDirectoryAggResource: no cloudId available on resource context');
	}

	const containerId = TownsquareSiteAri.create({ siteId: cloudId }).toString();
	return {
		environment: getAggRelayEnvironment(),
		query: GoalsDirectoryAggOuterQuery,
		variables: {
			customFieldContainerId: containerId,
			workspaceUuid: context.workspace?.UUID,
		},
	};
};

export const goalDirectoryAggResource = createRelayResource<GoalsDirectoryAggOuterQueryType>({
	getQuery: getGoalDirectoryAggResourceQuery,
});
